import { Form, Col, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select, { components } from "react-select";
import React, { useEffect, useRef } from "react";
import debounce from "lodash.debounce";

const MenuList = (props) => {
    const { isLoading, loadMore } = props.selectProps;

    const handleScroll = (event) => {
      const target = event.target;
      if (!target) return;

      const { scrollTop, scrollHeight, clientHeight } = target;

      if (scrollHeight - scrollTop <= clientHeight + 10 && !isLoading) {
        loadMore?.();
      }
    };

    return (
      <components.MenuList
        {...props}
        innerProps={{
          ...props.innerProps,
          onScroll: handleScroll,  // Attach the scroll event handler here
        }}
      >
        {props.children}
        {isLoading && (
          <div style={{ textAlign: "center", padding: "10px" }}>
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </components.MenuList>
    );
  };



const CustomDropdown = ({
    label,
    controlID,
    control,
    rowsData,
    loadMore,
    isLoading,
    onChange,
    remoteSearch = false,
    onSearchInputChange,
}) => {

    const { formState: { errors } } = useForm({ mode: "onBlur" });

    const searchCallbackRef = useRef(onSearchInputChange);
    useEffect(() => {
        searchCallbackRef.current = onSearchInputChange;
    }, [onSearchInputChange]);

    const debouncedRemoteSearch = useRef(
        debounce((inputValue) => {
            searchCallbackRef.current?.(inputValue ?? "");
        }, 400)
    ).current;

    useEffect(() => {
        return () => debouncedRemoteSearch.cancel();
    }, [debouncedRemoteSearch]);

    return <Col xs={12} sm={12} md={8} lg={4} xl={4}>
        <Form.Group className="mb-3" controlId={controlID}>
            <Form.Label>{label}</Form.Label>
            <Controller
                control={control}
                name={controlID}
                rules={{
                    required: true,
                }}
                render={({ field: { onChange: fieldOnChange, value } }) => (
                    <Select
                        name={controlID}
                        value={value}
                        onChange={(selectedOption) => {
                            fieldOnChange(selectedOption);  // Update react-hook-form
                            // Only call parent onChange if it's provided
                            if (onChange && typeof onChange === 'function') {
                                onChange(selectedOption);
                            }
                        }}
                        options={rowsData}
                        isSearchable={true}
                        filterOption={remoteSearch ? null : undefined}
                        onInputChange={(inputValue, meta) => {
                            if (!remoteSearch) return;
                            if (meta.action === "input-change") {
                                debouncedRemoteSearch(inputValue);
                            }
                        }}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        components={{ MenuList }}
                        loadMore={loadMore}      // Pass loadMore directly
                        isLoading={isLoading}    // Pass isLoading directly
                        // maxMenuHeight={60}
                    />
                )}
            />

            {errors[controlID] && (
                <Form.Text className="text-muted validationText hasError">
                    {label} is required
                </Form.Text>
            )}
        </Form.Group>
    </Col>


};

export default CustomDropdown;